/* eslint-disable @typescript-eslint/no-var-requires */
export const phoenixLuxurySearchByLocationMap = require('./phoenixLuxurySearchByLocationMap.graphql');
export const phoenixLuxurySearchByLocationMapFilters = require('./phoenixLuxurySearchByLocationMapFilters.graphql');
export const phoenixLuxurySearchByGeoQueryMap = require('./phoenixLuxurySearchByGeoQueryMap.graphql');
export const phoenixLuxurySearchByGeoQueryMapFilters = require('./phoenixLuxurySearchByGeoQueryMapFilters.graphql');
export const phoenixLuxuryPropertyInfo = require('./phoenixLuxuryPropertyInfo.graphql');
export const phoenixLuxurySearchByGeoQueryList = require('./phoenixLuxurySearchByGeoQueryList.graphql');
export const phoenixLuxurySearchByLocationList = require('./phoenixLuxurySearchByLocationList.graphql');
